export const TREE_TABLE_INDENT_PX = 24;

export interface TreeTableRow {
  id: string | number;
  depth: number;
  hasChildren: boolean;
  isExpanded: boolean;
  isMatch?: boolean;
}
